module.exports = __webpack_public_path__ + "static/media/Vaishnodevi_Township.71bf7208.pdf";